import { useEffect, useState } from "react";
import AddRankingCategory from "../rankingcategories/components/addRankingCategory";
import AdvanceTable from "../../../components/advanceTable";
import { Button } from "../../../components/ui/button";
import { Icon } from "@iconify/react";
import Common from "../../../helper/common";

const RankingCategories = () => {
  const [data, setData] = useState({});
  const [open, setOpen] = useState(false);
  const [refId, setRefId] = useState(null);

  useEffect(() => {
    if (!open && refId) {
      setRefId();
    }
  }, [open, refId]);

  useEffect(() => {
    getData();
  }, []);

  debugger;
  const getData = async () => {
    const response = await Common.ApiService.getInstance().request(
      "GetRankingCategory"
    );

    if (response?.data) {
      debugger;
      let obj = {
        data: response.data.map((item) => ({
          ...item,
          name: item.name,
          createdon: Common.Utility.ConvertTime(item.createdon),
          // createdby: item.createdby,
          isdeleted: item.isdeleted.toString(),
        })),
      };

      setData(obj);
    }
  };
  const columns = [
    { title: "Id", type: "text", isVisible: true, key: "id" },
    { title: "Name", type: "text", isVisible: true, key: "name" },
    { title: "Created By", type: "text", isVisible: false, key: "createdby" },
    { title: "Created On", type: "date", isVisible: true, key: "createdon" },
    { title: "Is Deleted", type: "text", isVisible: true, key: "isdeleted" },
  ];
  const actions = [
    {
      type: "edit",
      onClick: (val) => _onEdit(val.id),
    },
    {
      type: "delete",
      onClick: (val) => _handleDelete(val.id),
    },
  ];

  const _onEdit = async (id) => {
    setOpen(true);
    setRefId(id);
  };

  const _handleDelete = async (id) => {
    const isConfirmed = await Common.SweetAlert.confirmation(
      "Are you sure want to delete this Category?",
      "Delete Category"
    );

    if (isConfirmed) {
      let resp = await Common.ApiService.getInstance().request(
        `DeleteRankingCategory?id=${id}`,
        {},
        "Delete"
      );

      Common.SweetAlert.alert(resp.message, "success");

      setTimeout(() => {
        getData(1);
      }, 500);
    }
  };

  const _addUpdateTrigger = () => {
    <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
      <Icon icon="heroicons:pencil" className="h-4 w-4" />
    </Button>;
  };

  return (
    <>
      <div className="md:grid md:grid-cols-6 gap-3 h-150 w-150 "></div>
      {data?.data && (
        <AdvanceTable
          title={"Ranking Categories"}
          columns={columns.filter((item) => item.isVisible)}
          data={data}
          getData={getData}
          addButton={() => (
            <AddRankingCategory
              id={refId}
              onClose={() => getData()}
              open={open}
              setOpen={setOpen}
            />
          )}
          showAddButton
          actionButtons={actions}
          updateTrigger={_addUpdateTrigger}
        />
      )}
    </>
  );
};
export default RankingCategories;
